import React, { useState } from 'react'
import { makeStyles } from '@mui/styles'
import ThemeInterface from '@/theme-interface'
import lang from '@/lang'
import { useAppDispatch, useAppSelector } from '@/redux/store'
import { nextStep } from '@/redux/ducks/wizard/config'
import { ButtonSquare } from '@/modules/base/components/buttons'
import RegistrationStepCard from './components/registration-step-card'
import PasswordInput from './components/passwordInput'
import AvvConsent from './components/avv-consent'
import GtmService, { GtmEventTypes } from '@/modules/_services/gtm.service'

const useStyles = makeStyles((theme: ThemeInterface) => ({
  content: {
    display: 'flex',
    flexDirection: 'column',
    gap: 24,
    width: '100%',
  },
  nextButton: {
    height: 48,
    borderRadius: theme.borderRadiusPill,
    fontSize: theme.fontSizes.smedium,
  },
}))

const eventOmo = 'Passwort'

// registration step 2 of 3 (step 1 is the confirm email modal)
const REGISTRATION_STEP = 2

const OnboardingPassword = () => {
  const classes = useStyles()
  const dispatch = useAppDispatch()
  const { step, totalSteps } = useAppSelector(state => state.wizard.config)

  const [inputsValid, setInputsValid] = useState(false)
  const [avvInputsValid, avvSetInputsValid] = useState(true)
  // "Weiter" is always active - after a click the missing password or consent is named
  const [isSubmitted, setIsSubmitted] = useState(false)
  const subscriptions = useAppSelector(state => state.tenant.info.subscriptions)
  const userInfo = useAppSelector(state => state.user.info)
  const subscriptionTypeTypesLabel = subscriptions?.map(s => s.typeOfSubscription).join(', ') || ''

  const onButtonClick = () => {
    if (ENV.product === 'meinbuero') {
      GtmService.pushEvent({
        event: GtmEventTypes.MboOnboarding,
        'mbo-onboarding-step': 'kontaktdaten-complete',
      })
    } else {
      GtmService.pushEvent({
        event: GtmEventTypes.GaEventHub,
        eventCategory: 'Onboarding',
        eventAction: 'Weiter',
        email: userInfo?.email || '',
        eventLabel: `${eventOmo} abgeschlossen ${subscriptionTypeTypesLabel} (${step}/${totalSteps})`,
      })
      return true
    }
  }

  const next = () => {
    setIsSubmitted(true)
    if (!inputsValid || !avvInputsValid) return
    if (onButtonClick() === true) {
      dispatch(nextStep())
    }
  }

  return (
    <RegistrationStepCard
      step={REGISTRATION_STEP}
      title={lang.onboardingV2.password.title}
      text={lang.registration.password.text}
      dataQsId='onboarding-password'
      stickyFooter
      footer={(
        <ButtonSquare
          className={classes.nextButton}
          label={lang.registration.password.next}
          onClick={next}
          dataQsId='onboarding-password-next'
        />
      )}
    >
      <div className={classes.content}>
        <PasswordInput setInputsValid={setInputsValid} showError={isSubmitted} />
        <AvvConsent setInputsValid={avvSetInputsValid} showError={isSubmitted} dataQsId='onboarding-avv' />
      </div>
    </RegistrationStepCard>
  )
}

export default OnboardingPassword
